"use client";

import React from "react";
import { Car, CarFront, Gem, Truck, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const categories = [{
  id: "01",
  name: "Rooted in Purpose",
  description: "Discovering your divine calling through biblical foundations and practical stewardship.",
  icon: Car,
  features: ["Identity in Christ", "Kingdom Stewardship", "Daily Devotionals"]
}, {
  id: "02",
  name: "The Modern Disciple",
  description: "Navigating faith in a digital age while maintaining spiritual discipline and focus.",
  icon: CarFront,
  features: ["Digital Boundaries", "Spiritual Rhythms", "Community Growth"]
}, {
  id: "03",
  name: "Biblical Leadership",
  description: "Leading with humility and authority based on the servant-leadership model of Jesus.",
  icon: Gem,
  features: ["Servant Heart", "Visionary Faith", "Integrity in Action"]
}, {
  id: "04",
  name: "Scriptural Study",
  description: "Deep dives into hermeneutics and historical context for a richer understanding of Word.",
  icon: Truck,
  features: ["Contextual Analysis", "Greek & Hebrew Roots", "Theological Depth"]
}];
export default function RideCategories() {
  return <section data-section-id="224776" id="speaking-topics" className="py-20 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:text-left max-w-2xl">
          <h2 className="font-default text-3xl md:text-4xl font-bold tracking-tight mb-4">
            Ministry <span className="text-accent">Speaking Topics</span>
          </h2>
          <p className="text-secondary text-lg font-default">
            Dustin offers engaging sessions designed to equip believers with biblical wisdom and practical tools for a life of faith.
          </p>
        </div>

        <ScrollArea className="w-full pb-6 -mx-4 px-4 md:mx-0 md:px-0 md:pb-0">
          <div className="flex w-max space-x-4 md:w-auto md:grid md:grid-cols-2 lg:grid-cols-4 md:space-x-0 md:gap-6">
            {categories.map((category, i) => <div key={category.id} data-index={i} className="w-[280px] md:w-auto shrink-0">
                <Card className="h-full flex flex-col group relative overflow-hidden border-border hover:border-secondary transition-all duration-500 hover:shadow-lg bg-card">
                  {}
                  <div className="absolute -right-4 -top-4 font-serif text-8xl font-bold text-primary/5 select-none pointer-events-none transition-opacity duration-500 group-hover:opacity-10">
                    {category.id}
                  </div>
                  
                  <CardHeader>
                    <div className="mb-4 relative inline-flex">
                      {}
                      <div className="absolute inset-0 bg-accent/10 blur-xl rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                      <div className="relative bg-background p-4 rounded-md group-hover:bg-accent/5 transition-colors duration-500 border border-border group-hover:border-accent/30">
                        <category.icon className="w-8 h-8 text-accent transition-transform duration-500 group-hover:scale-110" />
                      </div>
                    </div>
                    <CardTitle className="font-default text-2xl tracking-tight text-primary">{category.name}</CardTitle>
                    <CardDescription className="text-base font-default mt-2 text-secondary">
                      {category.description}
                    </CardDescription>
                  </CardHeader>
                  
                  <CardContent className="flex-grow">
                    <ul className="space-y-2.5">
                      {category.features.map((feature, idx) => <li key={idx} data-index={idx} className="flex items-center text-sm text-secondary font-default">
                          <div className="w-1.5 h-1.5 rounded-md bg-accent/60 mr-3" />
                          {feature}
                        </li>)}
                    </ul>
                  </CardContent>
                  
                  <CardFooter className="pt-6">
                    <Button className="w-full group/btn border-accent text-primary hover:bg-accent hover:text-primary-foreground" variant="outline" asChild>
                      <Link to="/SpeakingPage">
                        Inquire for {category.id}
                        <ArrowRight className="w-4 h-4 ml-2 transition-transform duration-300 group-hover/btn:translate-x-1" />
                      </Link>
                    </Button>
                  </CardFooter>
                </Card>
              </div>)}
          </div>
          <ScrollBar orientation="horizontal" className="md:hidden" />
        </ScrollArea>
      </div>
    </section>;
}